import store from "../store"
import { POPUP_TOGGLE } from "../store/data/actionTypes"
import { v4 as uuidv4 } from "uuid";

export const closeAllPopup = () => {

  store.dispatch({
    type: POPUP_TOGGLE,
    payload: uuidv4()
  })
}



export default closeAllPopup